import { render, staticRenderFns } from "./UpdateForm.vue?vue&type=template&id=919e36a0&scoped=true&"
import script from "./UpdateForm.vue?vue&type=script&lang=js&"
export * from "./UpdateForm.vue?vue&type=script&lang=js&"
import style0 from "./UpdateForm.vue?vue&type=style&index=0&id=919e36a0&prod&lang=css&"
import style1 from "./UpdateForm.vue?vue&type=style&index=1&id=919e36a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "919e36a0",
  null
  
)

export default component.exports